import { AxiosResponse } from "axios";

import { apiPublicAxios } from "../../axios";
import { SECURE_DATA } from "../../resources";

export interface ISecureDataResponse {
  data: string;
  isSuccess: boolean;
}

export interface ISecureDataPageContent {
  logo?: string;
  title?: string;
  onLinkUsedMessage?: string;
  isTextData: boolean;
}

export const checkSecureLink = (
  code: string
): Promise<AxiosResponse<ISecureDataResponse>> => {
  return apiPublicAxios.get<ISecureDataResponse>(`${SECURE_DATA}/check`, {
    params: { code },
  });
};

export const getSecureLinkPageContent = (
  code: string
): Promise<AxiosResponse<ISecureDataPageContent>> => {
  return apiPublicAxios.get<ISecureDataPageContent>(
    `${SECURE_DATA}/pageContent`,
    {
      params: { code },
    }
  );
};

export const downloadSecureFile = (code: string): string => {
  const delimiter = process.env.REACT_APP_BASE_API_URL?.endsWith("/")
    ? ""
    : "/";
  return `${process.env.REACT_APP_BASE_API_URL}${delimiter}${SECURE_DATA}/file/check?code=${code}`;
};
